import * as React from "react";
import CryptoJS from "crypto-js";
//

import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import Logo from "../Avatar/Logo";
import Backdropcircle from "../Loading/Backdrop";

import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import AddressFormOne from "./components/AddressForm";
import AddressFormTwo from "./components/AddressFormTwo";
import AddressFormThree from "./components/AddressFormThree";
//
import { useAuth } from "../Auth/AuthProtecter";
import PositionedSnackbar from "../Alert/AlertPositionedSnackbar";

const PERSONAPPOINTMENT = process.env.REACT_APP_API_PERSONAPPOINTMENT;
const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const steps = ["Datos personales", "Dirección", "Telefono"];
function getStepContent(step, SetActiButtom) {
  switch (step) {
    case 0:
      return <AddressFormOne SetActiButtom={SetActiButtom} />;
    case 1:
      return <AddressFormTwo SetActiButtom={SetActiButtom} />;
    case 2:
      return <AddressFormThree SetActiButtom={SetActiButtom} />;
    default:
      throw new Error("Unknown step");
  }
}

export default function Checkout(props) {
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  const [severity, setSeverity] = React.useState("warning");
  const [openState, setOpenState] = React.useState(false);
  const [messageAlert, setMessege] = React.useState("");
  //
  const [activeStep, setActiveStep] = React.useState(0);
  const [ActiButtom, SetActiButtom] = React.useState(false);
  const [nameCliente, SetNameCliente] = React.useState(false);
  const [lastName, SetLastName] = React.useState(false);
  const [email, SetEmail] = React.useState(false);
  //
  const [openBackdropcircle, setOpenBackdropcircle] = React.useState(false);

  const navigate = useNavigate();

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      fetchResource();
    } else {
      setActiveStep(activeStep + 1);
      SetActiButtom(false);
    }
  };

  const handleInicio = () => {
    console.log("atras");
    navigate("/signin", { replace: true });
    window.location.reload();
  };

  const fetchResource = async () => {
    setOpenBackdropcircle(true);

    //
    const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
    const PostData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    SetNameCliente(PostData.firstname);
    SetLastName(PostData.lastname);
    SetEmail(PostData.email);

    console.log(PostData);
    try {
      const jsonpass = {
        method: "POST",
        body: JSON.stringify(PostData),
      };

      const respass = await fetch(`${Url}${PERSONAPPOINTMENT}`, jsonpass);
      const res_pass = await respass.json();

      if (respass.status === 200) {
        setActiveStep(activeStep + 1);
        SetActiButtom(false);
        console.log(res_pass);
        setOpenBackdropcircle(false);
      } else {
        console.log(res_pass);
        setSeverity("error");
        setOpenState(true);
        setMessege("Ocurrio un error");
        setOpenBackdropcircle(false);
      }
    } catch (error) {
      console.log("ERoooooorr", error);
    }
  };

  return (
    <>
      <CssBaseline enableColorScheme />
      {openBackdropcircle && <Backdropcircle />}

      <PositionedSnackbar
        open={openState}
        severity={severity}
        message={messageAlert}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: { sm: "space-between", md: "flex-end" },
          alignItems: "center",
          width: "100%",
          maxWidth: { sm: "100%", md: 600 },
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexGrow: 1,
          }}
        >
          <Stepper
            id="desktop-stepper"
            activeStep={activeStep}
            sx={{ width: "100%", height: 40 }}
          >
            {steps.map((label) => (
              <Step
                sx={{ ":first-of-type": { pl: 0 }, ":last-child": { pr: 0 } }}
                key={label}
              >
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          width: "100%",
          maxWidth: { sm: "100%", md: 600 },
          gap: { xs: 5, md: "none" },
        }}
      >
        <Stepper
          id="mobile-stepper"
          activeStep={activeStep}
          alternativeLabel
          sx={{ display: { sm: "flex", md: "none" } }}
        >
          {steps.map((label) => (
            <Step
              sx={{
                ":first-of-type": { pl: 0 },
                ":last-child": { pr: 0 },
                "& .MuiStepConnector-root": { top: { xs: 6, sm: 12 } },
              }}
              key={label}
            >
              <StepLabel
                sx={{
                  ".MuiStepLabel-labelContainer": { maxWidth: "70px" },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length ? (
          <Stack spacing={2} useFlexGap>
            {/* <Typography variant="h3">🛡️</Typography> */}

            <Logo />
            <Typography variant="h5">
              {nameCliente} {lastName}
            </Typography>
            <Typography variant="h7">
              Estamos encantados de informarte que tus datos han sido
              registrados con éxito. Ahora podrás proceder a solicitar tu cita
              de manera eficiente y rápida.
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Todas las solicitudes y comunicaciones se enviarán directamente a
              tu correo electrónico registrado:
              <strong>&nbsp;{email}</strong>. Agradecemos tu confianza en
              nuestros servicios y estamos aquí para asistirte en todo momento
            </Typography>
            <Button
              onClick={handleInicio}
              variant="contained"
              sx={{ alignSelf: "start", width: { xs: "100%", sm: "auto" } }}
            >
              Iniciar Sesión
            </Button>
          </Stack>
        ) : (
          <React.Fragment>
            {getStepContent(activeStep, SetActiButtom)}
            <Box
              sx={[
                {
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  alignItems: "end",
                  flexGrow: 1,
                  gap: 1,
                  pb: { xs: 1, sm: 0 },
                  mt: { xs: 2, sm: 0 },
                  mb: "5px",
                },
                activeStep !== 0
                  ? { justifyContent: "space-between" }
                  : { justifyContent: "flex-end" },
              ]}
            >
              {/* {activeStep !== 0 && (
                <Button
                  startIcon={<ChevronLeftRoundedIcon />}
                  onClick={handleBack}
                  variant="text"
                  sx={{ display: { xs: "none", sm: "flex" } }}
                >
                  Previous
                </Button>
              )}

              {activeStep !== 0 && (
                <Button
                  startIcon={<ChevronLeftRoundedIcon />}
                  onClick={handleBack}
                  variant="outlined"
                  fullWidth
                  sx={{ display: { xs: "flex", sm: "none" } }}
                >
                  Previous
                </Button>
              )} */}

              {ActiButtom && (
                <Button
                  variant="contained"
                  endIcon={<ChevronRightRoundedIcon />}
                  onClick={handleNext}
                  sx={{ mt: -6, width: { xs: "100%", sm: "fit-content" } }}
                >
                  {activeStep === steps.length - 1
                    ? "Enviar datos"
                    : "Continuar"}
                </Button>
              )}
            </Box>
          </React.Fragment>
        )}
      </Box>
    </>
  );
}
